/*
 * Interface strings, Chinese (Simplified).
 *
 * The "ui" bucket: everything outside the calculators. Every language the
 * picker offers has a full file here, so no English leaks into a translated
 * interface. Calculator text lives in i18n/calc, which is English and Spanish
 * only. Legal and disclaimer text is in neither: it stays English everywhere,
 * with legal.englishGoverning beside it.
 *
 * Plural keys end _one/_other and are chosen by Intl.PluralRules for this
 * language; Chinese, Thai, Vietnamese and Indonesian have one form, so they
 * carry only _other and every count lands there.
 */

/* NOT REVIEWED BY A NATIVE SPEAKER. */

const strings = {
  "landing.lead": "请使用您的 AquaNetica 账户登录以继续。",
  "landing.signIn": "登录",
  "landing.signUpFree": "注册免费。",
  "common.close": "关闭",
  "common.cancel": "取消",
  "profile.title": "系统档案 · {name}",
  "profile.subtitle": "Gia 会据此校准本项目中的每一个回答。不适用的字段可以留空。",
  "profile.species": "养殖品种",
  "profile.speciesPlaceholder": "例如：大西洋鲑",
  "profile.systemType": "系统类型",
  "profile.select": "请选择…",
  "profile.sys.ras": "RAS（循环水）",
  "profile.sys.flow": "流水式",
  "profile.sys.pond": "池塘",
  "profile.sys.cage": "网箱",
  "profile.sys.hatchery": "苗种场",
  "profile.sys.other": "其他",
  "profile.volume": "总水体（L）",
  "profile.temp": "目标水温（°C）",
  "profile.lifeStage": "生长阶段",
  "profile.lifeStagePlaceholder": "银化苗、幼鱼、亲鱼",
  "profile.location": "所在地",
  "profile.locationPlaceholder": "例如：福建，中国",
  "profile.notes": "补充说明",
  "profile.notesPlaceholder": "关于本系统，Gia 还需要知道的其他情况",
  "profile.save": "保存档案",
  "help.title": "关于与免责声明",
  "help.about": "Gia 是面向水产养殖从业者的 AI 助手，内置工程计算器。它依据参考资料和通用知识作答，帮助您梳理系统、水质与设备问题。",
  "legal.englishGoverning": "条款与免责声明以英文提供，并以英文版本为准。",
  "feature.notNow": "暂不",
  "feature.seePlans": "查看套餐",
  "lang.title": "语言",
  "lang.sub": "设定界面语言，以及 Gia 回答所用的语言，无论您用哪种语言提问。",
  "lang.auto": "自动（跟随浏览器和我的提问）",
  "pe.timeline.ASAP": "尽快",
  "pe.timeline.1–3 months": "1–3 个月",
  "pe.timeline.Just researching": "只是了解一下",
  "pe.condition.New": "全新",
  "pe.condition.Used": "二手",
  "pe.condition.Either": "都可以",
  "pe.missing.quantity": "需要多少台",
  "pe.missing.city": "发货到哪里",
  "pe.missing.date": "什么时候要",
  "pe.nudge": "供应商通常需要知道{list}才能报价。您也可以直接提交。",
  "pe.err.name": "请填写您的姓名，以便我们知道回复给谁。",
  "pe.err.email": "请填写您的邮箱，以便我们回复。",
  "pe.err.emailInvalid": "这个邮箱似乎不正确，请检查。",
  "pe.err.quantity": "请填写需要的数量。",
  "pe.err.city": "请填写收货城市。",
  "pe.err.send": "未能提交您的需求，请重试。",
  "pe.err.network": "无法连接服务器。请检查网络后重试。",
  "pe.title": "请帮我找到这台设备",
  "pe.thanks": "谢谢。我们会通过 {email} 与您联系。",
  "pe.done": "完成",
  "pe.whatYouNeed": "您需要的设备",
  "pe.equipment": "设备",
  "pe.suggestedModels": "推荐型号：",
  "pe.hideDetails": "收起详情",
  "pe.editDetails": "修改详情",
  "pe.item": "您需要的设备",
  "pe.specs": "参数与选型",
  "pe.name": "您的姓名",
  "pe.email": "邮箱（便于我们回复）",
  "pe.when": "您什么时候需要？",
  "pe.quantity": "您需要多少台？",
  "pe.quantityPlaceholder": "例如：2 台",
  "pe.city": "收货城市",
  "pe.cityPlaceholder": "发货到哪里？",
  "pe.neededBy": "最晚交付日期（选填）",
  "pe.condition": "全新还是二手？（选填）",
  "pe.budget": "大致预算（选填）",
  "pe.amount": "金额",
  "pe.budgetAmount": "预算金额",
  "pe.budgetCurrency": "预算币种",
  "pe.notSure": "不确定",
  "pe.note": "还有其他要求吗？（选填）",
  "pe.notePlaceholder": "任何有助于我们找到合适设备的信息。",
  "pe.hideFarm": "收起养殖场信息",
  "pe.addFarm": "补充养殖场信息（选填）",
  "pe.farm": "养殖场或公司名称",
  "pe.country": "国家/地区",
  "pe.sending": "提交中…",
  "pe.send": "提交需求",
  "pe.reassurance": "没有任何约束。AquaNetica 会有专人通过邮件回复您。",
  "toolbar.answerLanguage": "语言：{name}",
  "toolbar.answerLanguageTitle": "语言",
  "project.namePrompt": "项目名称？",
  "project.renamePrompt": "重命名项目：",
  "project.deleteWithChats": "删除项目“{name}”及其 {count} 个对话？",
  "project.deleteWithChats_other": "删除项目“{name}”及其 {count} 个对话？",
  "project.delete": "删除项目“{name}”？",
  "file.proTitle": "带附件的消息属于 Pro 功能",
  "file.proMessage": "您的套餐不包含带附件的消息。升级到 Pro 即可上传规格书、图纸和照片供 Gia 阅读。只要发送消息时带着附件，就算一条带附件的消息。",
  "file.badType": "请上传图片（JPG、PNG、GIF、WEBP）、PDF、Word、Excel、PowerPoint 文件（.docx、.xlsx、.pptx），或文本、代码文件（.txt、.md、.csv、.json、.r、.py）。",
  "file.tooLarge": "文件太大。附件请控制在 20 MB 以内。",
  "file.unreadable": "Gia 无法读取此文件。如果文件设有密码，或是旧版 .doc、.xls、.ppt 文件，请另存为不带密码的 .docx、.xlsx 或 .pptx 后重新上传。",
  "file.noText": "此文件中没有 Gia 能读取的文字。如果是扫描件或以图片为主，请改为以 PDF 或图片上传。",
  "file.tooBig": "此文件太大，Gia 无法一次读完。请拆分成较小的文件，或只上传需要的部分。",
  "file.notText": "此文件虽然文件名显示为文本，但实际不是纯文本。请另存为文本（UTF-8）后重新上传。",
  "chat.errSomething": "抱歉，出了点问题：{detail}",
  "chat.errNoBackend": "抱歉，无法连接知识库。请检查后端是否运行在 3001 端口。",
  "file.attached": "· 已附加到本对话",
  "file.left": "本月还剩 {count} 条带附件的消息",
  "file.left_other": "本月还剩 {count} 条带附件的消息",
  "file.detachTitle": "移除附件：不再计入带附件的消息",
  "file.detachLabel": "移除附件",
  "file.detach": "移除",
  "file.explain": "附件存在期间，您发送的每条消息都计为一条带附件的消息。Gia 不再需要参考时，请移除附件。",
  "file.reattachHint": "{name}：重新附加即可继续就该文件提问",
  "file.reattachTitle": "重新附加文件",
  "file.reattach": "重新附加",
  "usage.questions": "本月还剩 {left}/{limit} 次提问",
  "usage.questions_other": "本月还剩 {left}/{limit} 次提问",
  "usage.questionsShort": "还剩 {left}/{limit} 次提问",
  "usage.questionsShort_other": "还剩 {left}/{limit} 次提问",
  "usage.files": "还剩 {left}/{limit} 条带附件的消息",
  "usage.files_other": "还剩 {left}/{limit} 条带附件的消息",
  "usage.leftShort": "剩余 {left} 个问题",
  "usage.leftShort_other": "剩余 {left} 个问题",
  "usage.remaining": "剩余 {left} / {limit} 个问题",
  "usage.remaining_other": "剩余 {left} / {limit} 个问题",
  "usage.upgrade": "升级",
  "wall.daily": "您已达到今天的消息上限",
  "wall.feature": "{plan} 套餐不包含此功能",
  "wall.featureYour": "您的套餐不包含此功能",
  "wall.files": "本月 {plan} 套餐的 {limit} 条带附件消息已用完",
  "wall.questions": "本月 {plan} 套餐的 {limit} 次提问已用完",
  "wall.generic": "您已达到套餐的一项上限",
  "wall.region": "提问次数已用完",
  "wall.refresh": "您的 {plan} 套餐提问次数于每月 1 日重置。",
  "wall.refreshNoPlan": "您的提问次数于每月 1 日重置。",
  "wall.stayFree": "计算器始终免费且不限次数，之前的对话也都保留在这里可以查看。",
  "wall.upgrade": "前往 aquanetica.com 升级",
  "sidebar.hide": "隐藏侧边栏",
  "sidebar.search": "搜索对话…",
  "sidebar.newChat": "+ 新对话",
  "sidebar.newProject": "+ 项目",
  "sidebar.tools": "🛠️ 工具",
  "sidebar.backToGia": "返回 Gia",
  "sidebar.calculator": "计算器",
  "sidebar.empty": "还没有对话。向 Gia 提问即可开始。",
  "sidebar.profileSet": "已设置系统档案",
  "sidebar.newInProject": "在此项目中新建对话",
  "sidebar.editProfile": "编辑档案",
  "sidebar.rename": "重命名",
  "sidebar.delete": "删除",
  "sidebar.projectEmpty": "还没有对话",
  "sidebar.noMatches": "没有找到“{q}”的结果",
  "sidebar.signedIn": "已登录",
  "sidebar.signOut": "退出登录",
  "sidebar.signingOut": "正在退出登录…",
  "signout.title": "退出登录",
  "signout.body": "您将退出 AquaNetica IQ 和 aquanetica.com 的登录。上传的文档和回答评分始终会从本设备删除。您保存的其他内容会保留在这里，供您下次登录使用。",
  "signout.alsoClear": "同时删除本设备上保存的工作：对话、项目和计算内容",
  "signout.irreversible": "此额外删除不可撤销。这些内容仅保存在此浏览器中，没有可供恢复的副本。",
  "signout.confirm": "退出登录",
  "sidebar.communityTitle": "返回 AquaNetica 社区（在新标签页打开）",
  "sidebar.community": "返回 AquaNetica",
  "sidebar.help": "帮助与免责声明",
  "drop.label": "松开即可添加附件",
  "toolbar.showSidebar": "显示侧边栏",
  "toolbar.toggleSidebar": "显示或隐藏侧边栏",
  "toolbar.newChat": "新对话",
  "toolbar.inProject": "所在项目：",
  "toolbar.home": "返回 AquaNetica 社区",
  "toolbar.homeTitle": "返回 AquaNetica（在新标签页打开）",
  "toolbar.calc": "打开计算器",
  "toolbar.theme": "切换深浅色",
  "hero.title": "有什么可以帮您？",
  "hero.calibrated": "Gia 已按本项目的系统档案进行校准。",
  "hero.noProfile": "尚未填写系统档案。点击项目上的 ⚙ 即可填写。",
  "hero.subtitle": "关于养殖系统、水质或设备，什么都可以问。",
  "composer.attachTitle": "上传图片或 PDF",
  "composer.attachLabel": "上传文件",
  "composer.send": "发送",
  "answer.copyTitle": "复制回答",
  "answer.copied": "已复制",
  "answer.copy": "复制",
  "answer.retryTitle": "重新提问",
  "answer.retryLabel": "重新生成回答",
  "answer.retry": "重试",
  "answer.good": "回答不错",
  "answer.bad": "回答不好",
  "answer.sourcing": "需要帮忙采购吗？ →",
  "answer.searching": "正在检索资料库…",
  "answer.scrollLatest": "回到最新",
  "sidebar.otherChats": "其他",
  "trial.have": "有兑换码？",
  "trial.title": "试用码",
  "trial.placeholder": "请输入试用码",
  "trial.submit": "兑换",
  "trial.checking": "正在验证…",
  "trial.invalid": "该码无效，请检查后重试。",
  "trial.error": "无法验证该码，请重试。",
  "trial.success": "Pro 试用已开始。到 {date} 为止，每月可提问 75 次、发送 10 条带附件的消息。",
  "trial.active": "Pro 试用至 {date}",
  "sidebar.planTrial": "{plan} 试用",
  "sidebar.managePlan": "管理套餐",
  "trial.ends": "试用期至 {date}",
  "pe.consent": "我同意将我的需求信息提供给 AquaNetica，以及代表我联系的供应商，并同意{terms}和{privacy}。",
  "pe.consentTerms": "服务条款",
  "pe.consentPrivacy": "隐私政策",
};

export default strings;
